module.exports = __webpack_public_path__ + "img/zhanwushuju@3x.1dd76534.png";